const timeIntervals = [{
  min: 0,
  max: 10,
  title: 'до 10м'
},
{
  min: 10,
  max: 25,
  title: 'до 25м'
},
{
  min: 25,
  max: 30,
  title: 'до 30м'
},
{
  min: 30,
  max: 40,
  title: 'до 40м'
},
{
  min: 40,
  title: '> 40м'
},
{
  avg: true,
  title: 'Среднее'
}]
export {timeIntervals}



// WEBPACK FOOTER //
// ./src/componentsSettings/tableDetailedStats.js